import { CritType, ITableDemandItem } from '@models/winnerSelection/ITableDemand';

/* Метки + поясняющие диапазоны для шкал оценки.
 * Источник — компоненты в OfferCritDetails/RatingScales/*.tsx:
 *   default (''): 0..5 (input float)
 *   pstz:         0..5 (input float, округление до сотых)
 *   tmcws:        {5, 2}    (select)
 *   pirsmr:       {5, 4, 3, 2} (select)
 *   simtum:       {5, 4, 3, 2} (select)
 * Метка — компактное имя + диапазон в скобках (для tooltip — полный список). */
export const RATING_SCALE_LABEL: Record<string, string> = {
    simtum: 'СимТюм',
    pirsmr: 'ПИР-СМР',
    pstz: 'ПСТЗ',
    tmcws: 'ТМЦ-WS',
    '': 'шкала 0–5',
};

export const RATING_SCALE_RANGE: Record<string, string> = {
    simtum: '2, 3, 4, 5',
    pirsmr: '2, 3, 4, 5',
    pstz: '0–5',
    tmcws: '2, 5',
    '': '0–5',
};

/**
 * Effective тип критерия. critType — приоритетный (XML-настройка),
 * fallback на isInfoCrit (legacy-флаг для информационных критериев).
 */
export const getEffectiveCritType = (row: ITableDemandItem): Exclude<CritType, null> => {
    return row.critType ?? (row.isInfoCrit ? 'info' : 'score');
};
